<template>
  <!-- @name 文字组件颜色设置
    -- @author liuguisheng
    -- @date 2020-2-28
    -->
  <div class="setting-item">
    <el-form-item label="文字颜色"> 
        <el-color-picker v-model="color"></el-color-picker>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';

export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 文字颜色
     *  @description 将 color 字段映射到当前 color 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-09-25
     */
    ...mapComputed({
      color: { 
        parent: i => i.styleOption,
        attr: "color"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/style_setting/SettingTextColor.vue